import { useState } from 'react';
import { Button, ButtonTheme } from '@apply/components';
import { DrawSummaryPopup } from '@apply/ui/src/lib/tables/draws/drawsV2/DrawSummaryPopup';
import { IDrawHistory } from '@apply/api/src/api/DrawApi';

interface ViewDrawButtonProps {
    drawBudgetId: number;
    drawHistoryLines: IDrawHistory[];
}

export const ViewDrawButton = ({ drawBudgetId, drawHistoryLines }: ViewDrawButtonProps) => {
    const [open, set_open] = useState<boolean>(false);

    return (
        <>
            <Button
                id='secondaryButton'
                theme={ButtonTheme.Secondary}
                width='160px'
                handleClick={() => set_open(true)}
            >
                View
            </Button>
            {open && (
                <DrawSummaryPopup
                    drawBudgetId={drawBudgetId}
                    drawHistoryLines={drawHistoryLines}
                    open={true}
                    handleCloseEvent={() => set_open(false)}
                    tabShown={'available'}
                />
            )}
        </>
    );
};
